import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { compose } from 'react-apollo';
import { Button, TypographyStyle, TypographyWeight } from '@treelab/panda';

import { Typography } from '../../Typography';
import { InputRadio } from '../../Input';
import { Modal } from '../';
import { IRootState, IDispatch } from '../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  onClose: () => void;
}

const ModalSettings: React.FC<IProps> = ({
  onClose,
  isPortrait,
  saveSpaceConfigsByTemplate,
  updatePortraitMode,
  intl: { formatMessage },
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const onDone = useCallback(async () => {
    setIsLoading(true);
    await saveSpaceConfigsByTemplate();
    setIsLoading(false);
    onClose();
  }, [onClose, saveSpaceConfigsByTemplate]);

  return (
    <Modal onClose={onClose} style={{ height: 'fit-content', width: '350px' }}>
      <>
        <Typography
          type={TypographyStyle.H3}
          weight={TypographyWeight.Medium}
          style={{ marginBottom: '16px' }}
        >
          {formatMessage({ id: 'controls.settings' })}
        </Typography>
        <InputRadio
          input={{
            onChange: (value) => updatePortraitMode(value === 'portrait'),
            name: formatMessage({ id: 'print.orientation.prompt' }),
            value: isPortrait ? 'portrait' : 'landscape',
          }}
          meta={{}}
          isSmall
          options={[
            { name: formatMessage({ id: 'global.orientation.portrait' }), value: 'portrait' },
            { name: formatMessage({ id: 'global.orientation.landscape' }), value: 'landscape' },
          ]}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
          <Button isLoading={isLoading} onClick={onDone}>
            {formatMessage({ id: 'global.button.done' })}
          </Button>
        </div>
      </>
    </Modal>
  );
};

const mapState = ({ space }: IRootState) => ({
  isPortrait: space.isPortrait,
});

const mapDispatch = ({ space }: IDispatch) => ({
  saveSpaceConfigsByTemplate: space.saveSpaceConfigsByTemplate,
  updatePortraitMode: space.updatePortraitMode,
});

export default compose(
  injectIntl,
  connect(
    mapState,
    //@ts-ignore
    mapDispatch,
  ),
)(ModalSettings);
